/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Configuration for AWS Native PITR (Point-in-Time Recovery) backup policies
*/
export class AwsNativePitrConfig {
  /**
  * Number of days to retain continuous backups using AWS Backup. AWS allows 1-35 days for RDS/Aurora continuous backups. 
  */
  'retentionDays'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsNativePitrConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

